/**
 * @generated SignedSource<<76956d4fc3378e547623ef5c7ad60a5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carSpaces",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "routes_VehiclePark_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleParking",
        "kind": "LinkedField",
        "name": "vehicleParking",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ParkContainer_vehicleParking"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "routes_VehiclePark_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "VehicleParking",
        "kind": "LinkedField",
        "name": "vehicleParking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleParkingSpaces",
            "kind": "LinkedField",
            "name": "availability",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bicycleSpaces",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VehicleParkingSpaces",
            "kind": "LinkedField",
            "name": "capacity",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lon",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tags",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "realtime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a596babe01893217452a69c48c590c02",
    "id": null,
    "metadata": {},
    "name": "routes_VehiclePark_Query",
    "operationKind": "query",
    "text": "query routes_VehiclePark_Query(\n  $id: String!\n) {\n  vehicleParking(id: $id) {\n    ...ParkContainer_vehicleParking\n    id\n  }\n}\n\nfragment ParkContainer_vehicleParking on VehicleParking {\n  availability {\n    bicycleSpaces\n    carSpaces\n  }\n  capacity {\n    carSpaces\n  }\n  name\n  lat\n  lon\n  tags\n  realtime\n}\n"
  }
};
})();

node.hash = "5241e04c2b9e1b856e1fb9521b6dec7d";

module.exports = node;
